<template>
	<div class="wrap">
		<div class="content">
			<div class="form-title">
				<form-title :tip="tip" :flag="flag" :tip3="tip3"></form-title>
			</div>
			<div class="edit-form">
				<el-form
					:model="editForm"
					:rules="rules"
					ref="editForm"
					label-width="100px"
					class="form"
				>
					<el-form-item label="员工编码" prop="erpcode">
						<el-input
							v-model="editForm.erpcode"
							placeholder="请填写HR-ERP系统的员工编码"
							clearable
						/>
					</el-form-item>
					<el-form-item label="姓名" prop="name">
						<el-input disabled v-model="editForm.name" clearable />
					</el-form-item>
					<el-form-item label="证件号码" prop="idNum">
						<el-input disabled v-model="editForm.idNum" clearable />
					</el-form-item>
					<el-form-item style="text-align: center">
						<el-button type="primary" @click="submit('editForm')">
							提交认证
						</el-button>
						<el-button @click="resetForm('editForm')" type="info">
							重置
						</el-button>
					</el-form-item>
				</el-form>
			</div>
		</div>
	</div>
</template>

<script>
import formTitle from "../common/formTitle";
import { authUser } from "../request/regAndEdit";
import { isLogin, getLoginUser, setLoginUser } from "../../utils/auth";

export default {
	name: "auth",
	components: {
		formTitle,
	},
	data() {
		return {
			editForm: {
				erpcode: "",
				name: "",
				idNum: "",
			},
			userInfo: {},
			show: true,
			disabledCodeBtn: true,
			count: "",
			timer: null,
			tip: "身份认证",
			tip3: "请填写HR-ERP系统的员工编码",
			flag: true,
			rules: {
				erpcode: [
					{
						required: true,
						message: "请输入HR-ERP系统员工编码",
						trigger: "blur",
					},
				],
				name: [
					{
						required: true,
						message: "会话已过期，请重新登录",
						trigger: "blur",
					},
				],
				idNum: [
					{
						required: true,
						message: "会话已过期，请重新登录",
						trigger: "blur",
					},
				],
			},
		};
	},
	methods: {
		//修改完成提交
		submit(formName) {
			this.$refs[formName].validate((valid) => {
				if (valid) {
					this.authUser();
				} else {
					return false;
				}
			});
		},
		authUser() {
			let params = {
				erpcode: this.editForm.erpcode,
				name: this.editForm.name,
				id: this.editForm.idNum,
			};
			authUser(params).then((res) => {
				if (res.code === 1) {
					this.$message({
						message: `身份认证成功`,
						type: "info",
					});

					setTimeout(() => {
						//修改成功后再更新前端存储
						this.userInfo.hrpsn = 1;
						this.$cookie.set("userInfo", this.userInfo);
						setLoginUser(this.userInfo);
						this.$router.push("/");
					}, 1500);
				} else {
					this.$message({
						message: res.message,
						type: "info",
					});
					return;
				}
			});
		},
		resetForm(formName) {
			this.$refs[formName].resetFields();
		},
	},
	created() {
		if (isLogin()) {
			this.userInfo = getLoginUser();
			if (this.userInfo.length != 0) {
				this.editForm.name = this.userInfo.Name;
				this.editForm.idNum = this.userInfo.ID;
			}
		}
	},
	mounted() {},
};
</script>

<style lang="scss" scoped>
.wrap {
	width: 100%;
	height: auto;

	.content {
		width: 1200px;
		margin: 0 auto;
		margin-top: 100px;
		margin-bottom: 600px;

		.form-title {
			width: 100%;
			height: 100px;
			border-bottom: 1px solid rgb(234, 234, 234);
			box-sizing: border-box;
			margin-bottom: 50px;
		}

		.edit-form {
			width: 72%;
			margin: 0 auto;
		}
	}
}

::v-deep .el-input {
	width: 743px;
}
</style>
